import { render, staticRenderFns } from "./relatMerchant.vue?vue&type=template&id=5431a7c2&scoped=true"
import script from "./relatMerchant.vue?vue&type=script&lang=js"
export * from "./relatMerchant.vue?vue&type=script&lang=js"
import style0 from "./relatMerchant.vue?vue&type=style&index=0&id=5431a7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431a7c2",
  null
  
)

export default component.exports